export const signInForm = {
    email: '',
    password: ''
};
export const errorSignIn = {
    email: '',
    password: ''
};
